/**
 * Video Uploader with Preview Video
 * 
 * @author Michael Zenner <mzenner@perrill.com>
 * @version 1.0.1
 * @since 8-5-2022
 * 

 * 
 *** Html Usage:
 * 

 * data-required - if the video field is required
 * data-name - fills in the "name" on the input field for form handling
 * data-existing - fill in with path from database if video already exists

<div class="video-preview"
     data-required="true"
     data-name="media_id"
     data-existing="/path/to/video">
</div>

 * 
 */

window.VideoPreview = new function()
{
 this.init = function() {
    VideoPreview.buildHtml();

    jQuery('body').on('click', '.video-preview .add-video', function(event) {
        event.preventDefault();
        VideoPreview.addInput(this);
    });

    jQuery('body').on('change', '.video-preview input', function(event) {
        event.preventDefault();
        VideoPreview.buildPreview(this);
    });

    jQuery('body').on('click', '.video-preview .remove-video', function(event) {
        event.preventDefault();
        VideoPreview.remove(this);
    });

    jQuery('body').on('submit', 'form', function(event) {
        jQuery('.video-preview').each(function(index, el) {
            var required = jQuery(el).data('required');

            if(required) {
               if(!jQuery(el).find('video.preview-video').length) {
                   event.preventDefault();

                   jQuery(el).find('.error').remove();
                   jQuery(el).append('<p class="error">Required Field*</p>');
                   
                   return false;
               } 
            }
        });
    });
 };

 /**
  * Build DOM for each video-preview present on the page
  */
 this.buildHtml = function() {
    jQuery('.video-preview:not(.initialized)').each(function(index, el) {
        jQuery(el).addClass('initialized');
        
        if(jQuery(el).data('existing')) {
            var html = '<a href="javascript:;" title="Replace Video" class="edit add-video">';
        } else {
            var html = '<a href="javascript:;" title="Add Video" class="add-video">';
        }
        
        if(jQuery(el).data('existing')) {
            var src = jQuery(el).data('existing');
            html += '<video width="320" height="240" controls class="preview-video">' + 
            '<source src="' + src + '" type="video/mp4">' +
            'Your browser does not support the video tag.' +
            '</video>';
        } else {
            html += '<span class="wrap text-center">';
            html += '<i class="fa-regular fa-cloud-arrow-up"></i>';
            html += '<span class="display-block text-center">Upload Video</span>';
            html += '</span>';
        }

        html += '</a>';

        if(jQuery(el).data('existing')) {
            html += '<a class="remove-video" href="javascript:;" title="Remove Video"><i class="fa fa-close"></i></a>';
        } else {
            html += '<a class="remove-video" href="javascript:;" title="Remove Video" style="display:none;"><i class="fa fa-close"></i></a>';
        }
        
        jQuery(el).html(html);
    });
 };

 /**
  * Adds empty input to DOM
  *
  * @param obj el - video-preview anchor tag clicked
  */
 this.addInput = function(el) {
    var name = jQuery(el).closest('.video-preview').data('name');

    jQuery(el).closest('.video-preview').find('.error').remove();
    jQuery(el).closest('.video-preview').find('input').remove();
    jQuery('#' + name).remove();
    jQuery(el).closest('.video-preview').append("<input type='file' id='" + name + 
        "' style='display:none;' name='" + name + "[]' accept='.mp4,.mov' />");
    jQuery('#' + name).trigger('click');
 };

 /**
  * Show preview of uploaded file
  *
  * @param obj el - file input uploaded to
  */
 this.buildPreview = function(el) {
    var file = $(el).get(0);

    if(el.files[0].size > 1000000000) {
       alert("Max upload size is 1 gigabyte");
       return false;
    };

    var preview = window.URL.createObjectURL(file.files[0]);

    jQuery(el).closest('.video-preview').find('.preview-video').remove();
    jQuery(el).closest('.video-preview').find('.add-video').html('<div class="preview-video">' +
            '<video width="320" height="240" controls class="preview-video">' + 
            '<source src="' + preview + '" type="video/mp4">' +
            'Your browser does not support the video tag.' +
            '</video></div>');
    jQuery(el).closest('.video-preview').find('.add-video').addClass('edit');
    jQuery(el).closest('.video-preview').find('.remove-video').css('display', '');
 };

 /**
  * Removes uploaded file
  *
  * @param obj el - remove button clicked
  */
 this.remove = function(el) {
    jQuery(el).closest('.video-preview').find('input').remove();
    jQuery(el).closest('.video-preview').find('.add-video').empty();
    jQuery(el).closest('.video-preview').find('.add-video').removeClass('edit');
    jQuery(el).css('display', 'none');

    var name = jQuery(el).closest('.video-preview').data('name');
    jQuery(el).closest('.video-preview').append('<input type="hidden" name="remove_' + name + '" value="1">');

    var html = '<span class="wrap text-center">';
    html += '<i class="fa-regular fa-cloud-arrow-up"></i>';
    html += '<span class="display-block text-center">Upload Video</span>';
    html += '</span>';
    jQuery(el).closest('.video-preview').find('.add-video').html(html);
 };
}

jQuery(document).ready(function($) {
    VideoPreview.init();
});
